import { render, staticRenderFns } from "./Emissions.vue?vue&type=template&id=4b041519"
import script from "./Emissions.vue?vue&type=script&lang=js"
export * from "./Emissions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports